import { render, staticRenderFns } from "./FirmasConfig.vue?vue&type=template&id=286822cf&"
import script from "./FirmasConfig.vue?vue&type=script&lang=js&"
export * from "./FirmasConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports